// extracted by css-extract-rspack-plugin
export default {"gridContainer":"_4d51bc6","itemsPerRow4":"_81997466"};